import type { Variant, Variants } from '@amplitude/experiment-js-client'

export const featureFlagKeys = {
  websockets: 'websockets',
  darkMode: 'darkmode',
  // tradingPoc: 'tradingpoc',
  // ibDashboardPoc: 'ibdashboardpoc',
  // gamification: 'gamification',
  // alternativeUI: 'alternativeui',
  cryptoWallets: 'cryptowallets',
  marketDataWSType: 'marketdatawstype',
} as const

export type FeatureFlags = {
  websockets: boolean
  darkMode: boolean
  // tradingPOC: boolean
  // ibDashboardPOC: boolean
  // gamification: boolean
  cryptoWallets: boolean

  // alternativeUI:
  //   | 'standard'
  //   | 'green-light-text'
  //   | 'green-dark-text'
  //   | 'green'
  //   | 'purple'
  //   | 'blue'
  //   | 'purple-to-blue'
  //   | 'white'
  //   | 'black'
  //   | 'black-and-white'
  marketDataWSType: 'notifications-hub' | 'legacy'
}

export const defaultFeatureFlags: FeatureFlags = {
  websockets: false,
  darkMode: false,
  // tradingPOC: false,
  // ibDashboardPOC: false,
  // gamification: false,
  // alternativeUI: 'standard',
  cryptoWallets: false,
  marketDataWSType: 'legacy',
}

const getPayloadEnabledValue = (payload: Variant['payload']): boolean | undefined => {
  if (typeof payload === 'boolean') return payload

  if (
    typeof payload === 'object' &&
    payload !== null &&
    'enabled' in payload &&
    typeof payload.enabled === 'boolean'
  ) {
    return payload.enabled
  }

  return undefined
}

export const isFeatureVariantEnabled = (variant?: Variant): boolean => {
  if (!variant) return false

  const payloadEnabledValue = getPayloadEnabledValue(variant.payload)
  if (payloadEnabledValue !== undefined) return payloadEnabledValue

  const rawValue = variant.value ?? variant.key
  if (!rawValue) return false

  const normalizedValue = String(rawValue).trim().toLowerCase()

  return normalizedValue === 'on'
}

export const resolveFeatureFlags = (variants: Variants): FeatureFlags => ({
  websockets: isFeatureVariantEnabled(variants[featureFlagKeys.websockets]),
  darkMode: isFeatureVariantEnabled(variants[featureFlagKeys.darkMode]),
  // tradingPOC: isFeatureVariantEnabled(variants[featureFlagKeys.tradingPoc]),
  // ibDashboardPOC: isFeatureVariantEnabled(variants[featureFlagKeys.ibDashboardPoc]),
  // gamification: isFeatureVariantEnabled(variants[featureFlagKeys.gamification]),
  // alternativeUI:
  //   (variants[featureFlagKeys.alternativeUI].value as FeatureFlags['alternativeUI']) ??
  //   defaultFeatureFlags.alternativeUI,
  cryptoWallets: isFeatureVariantEnabled(variants[featureFlagKeys.cryptoWallets]),
  marketDataWSType:
    variants[featureFlagKeys.marketDataWSType]?.value === 'notifications-hub'
      ? 'notifications-hub'
      : defaultFeatureFlags.marketDataWSType,
})
